<script setup>
/**
 * Table row wrapper, for use in custom body rows inside HrTable.
 *
 * @status recommended
 * @group lists-tables
 * @useWhen Rendering a whole custom row — an expandable row, a group header, or one whose cells
 *   vary — in a table built with HrTable. Per-column `body-cell-*` slots do not need one.
 * @avoidWhen The table renders one row per `rows` entry — the default body already does that
 * @related HrTd
 * @related HrTh
 * @within hr-table
 * @a11y Renders a native `tr`, which is not focusable — a row acting as a control needs its own control.
 * @see https://quasar.dev/vue-components/table Quasar q-tr API
 */
// inheritAttrs: false because the template spreads $attrs onto the q-tr itself. Without it
// Vue's own fallthrough applies them a second time.
defineOptions({ name: 'HrTr', inheritAttrs: false });
</script>

<template>
  <q-tr v-bind="$attrs">
    <!-- @slot default Table cells (HrTd or HrTh) for this row. -->
    <slot />
  </q-tr>
</template>
